import React, { FC } from 'react';

type ManualIconProps = {
  className?: string;
};

import './ManualIcon.scss';

const ManualIcon: FC<ManualIconProps> = ({ className = '' }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path d="M18,2H6A2,2,0,0,0,4,4V5A1,1,0,0,0,6,5V4h5V20H10a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2H13V4h5V5a1,1,0,0,0,2,0V4A2,2,0,0,0,18,2Z" />
  </svg>
);

export default ManualIcon;
